import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { UsersIcon, TrashIcon } from 'lucide-react';
import Button from '../../components/ui/Button';
import { useOrder } from '../../context/OrderContext';
const GroupOrderSummary: React.FC = () => {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const navigate = useNavigate();
  const {
    getCurrentGroupOrder
  } = useOrder();
  // Mock participants data
  const [participants] = useState([{
    id: 'user-1',
    name: 'Terry Crews (You)',
    items: [{
      id: 'item-1',
      name: 'Fried Egg with Tomato',
      quantity: 2,
      price: 7.5
    }],
    total: 15.0
  }, {
    id: 'user-2',
    name: 'Jane Smith',
    items: [{
      id: 'item-2',
      name: 'Fried Egg with Tomato',
      quantity: 1,
      price: 7.5
    }],
    total: 7.5
  }]);
  const totalAmount = participants.reduce((sum, p) => sum + p.total, 0);
  const deliveryFee = 2.5;
  const tax = totalAmount * 0.07;
  const finalTotal = totalAmount + deliveryFee + tax;
  return <div className="max-w-3xl mx-auto px-4" data-id="element-628">
      <div className="bg-white rounded-lg shadow-md p-4 sm:p-6" data-id="element-629">
        <div className="flex items-center mb-4 sm:mb-6" data-id="element-630">
          <div className="w-10 h-10 bg-[#E84118] bg-opacity-10 rounded-full flex items-center justify-center mr-3 sm:mr-4" data-id="element-631">
            <UsersIcon size={20} className="text-[#E84118]" data-id="element-632" />
          </div>
          <div data-id="element-633">
            <h1 className="text-lg sm:text-xl font-bold" data-id="element-634">
              Group Order Summary
            </h1>
            <p className="text-xs sm:text-sm text-gray-600" data-id="element-635">Order #{id}</p>
          </div>
        </div>
        {/* Participants orders */}
        <div className="space-y-4 sm:space-y-6" data-id="element-636">
          {participants.map(participant => <div key={participant.id} className="border rounded-lg overflow-hidden" data-id="element-637">
              <div className="bg-gray-50 p-3 sm:p-4 flex justify-between items-center" data-id="element-638">
                <div className="flex items-center" data-id="element-639">
                  <div className="w-7 h-7 sm:w-8 sm:h-8 bg-gray-200 rounded-full flex items-center justify-center mr-2 sm:mr-3" data-id="element-640">
                    {participant.name.charAt(0)}
                  </div>
                  <span className="font-medium text-sm sm:text-base" data-id="element-641">
                    {participant.name}
                  </span>
                </div>
                <button className="text-gray-400 hover:text-red-500" data-id="element-642">
                  <TrashIcon size={16} className="sm:w-5 sm:h-5" data-id="element-643" />
                </button>
              </div>
              <div className="p-3 sm:p-4" data-id="element-644">
                {participant.items.map(item => <div key={item.id} className="flex justify-between items-center mb-2" data-id="element-645">
                    <div data-id="element-646">
                      <p className="font-medium text-sm sm:text-base" data-id="element-647">
                        {item.name}
                      </p>
                      <p className="text-xs sm:text-sm text-gray-500" data-id="element-648">
                        Quantity: {item.quantity}
                      </p>
                    </div>
                    <span className="text-sm sm:text-base" data-id="element-649">
                      ${(item.price * item.quantity).toFixed(2)}
                    </span>
                  </div>)}
                <div className="border-t border-gray-200 mt-3 pt-3 flex justify-between font-medium text-sm sm:text-base" data-id="element-650">
                  <span data-id="element-651">Subtotal</span>
                  <span data-id="element-652">${participant.total.toFixed(2)}</span>
                </div>
              </div>
            </div>)}
        </div>
        {/* Order summary */}
        <div className="mt-6 sm:mt-8 bg-gray-50 rounded-lg p-3 sm:p-4" data-id="element-653">
          <h2 className="font-semibold mb-3 sm:mb-4 text-base sm:text-lg" data-id="element-654">
            Order Summary
          </h2>
          <div className="space-y-2 text-sm sm:text-base" data-id="element-655">
            <div className="flex justify-between" data-id="element-656">
              <span className="text-gray-600" data-id="element-657">Subtotal</span>
              <span data-id="element-658">${totalAmount.toFixed(2)}</span>
            </div>
            <div className="flex justify-between" data-id="element-659">
              <span className="text-gray-600" data-id="element-660">Delivery Fee</span>
              <span data-id="element-661">${deliveryFee.toFixed(2)}</span>
            </div>
            <div className="flex justify-between" data-id="element-662">
              <span className="text-gray-600" data-id="element-663">Tax (7%)</span>
              <span data-id="element-664">${tax.toFixed(2)}</span>
            </div>
            <div className="border-t border-gray-200 pt-2 mt-2 flex justify-between font-bold" data-id="element-665">
              <span data-id="element-666">Total</span>
              <span data-id="element-667">${finalTotal.toFixed(2)}</span>
            </div>
          </div>
        </div>
        <div className="mt-6 sm:mt-8 space-y-3 sm:space-y-4" data-id="element-668">
          <Button onClick={() => navigate('/checkout')} fullWidth size="lg" data-id="element-669">
            Finalize Order
          </Button>
          <Button variant="outline" onClick={() => navigate('/food')} fullWidth data-id="element-670">
            Add More Items
          </Button>
        </div>
      </div>
    </div>;
};
export default GroupOrderSummary;